import { PhysicalCardStatus } from 'src/models/creditCard.models'

// Card details a card is missing before physical-card enrollment can proceed.
// Generic (not issuer-specific) — see extend-api's MissingCardDetail. EX-40639.
export enum MissingCardDetail {
  CardNumber = 'CARD_NUMBER',
  Expiry = 'EXPIRY',
  Cvc = 'CVC',
}

/** Physical-card statuses that mean enrollment/confirmation is done — no further 3DS/CVS step needed. */
export const isCompletePhysicalCardStatus = (
  status?: PhysicalCardStatus | null,
): boolean =>
  status === PhysicalCardStatus.Active ||
  status === PhysicalCardStatus.NeedsCVSVerification
